module.exports = __webpack_public_path__ + "static/media/school_7.f425fce4.jpg";